import { render, staticRenderFns } from "./GitVersion.vue?vue&type=template&id=a53f1e92&"
import script from "./GitVersion.vue?vue&type=script&lang=ts&"
export * from "./GitVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports